import { client } from "./client";

// eslint-disable-next-line
export const exportWallet = params => client.post("wallets/export", params);

// eslint-disable-next-line
export const getWallet = () => client.get("wallets");

// eslint-disable-next-line
export const getOverdraft = () => client.get("wallet_overdrafts");

// eslint-disable-next-line
export const getExtract = params => client.get("wallet-extract", { params: params });

// eslint-disable-next-line
export const slipRecharge = params => client.post("bills", { bill: params });

// eslint-disable-next-line
export const selfSlipRecharge = params => client.post("bills/self-recharge", { bill: params });

export const newBillPayment = params => client.post("/bill_payments", { bill_payment: params });

// eslint-disable-next-line
export const billsList = params => client.get("bills", { params: params });

// eslint-disable-next-line
export const billsPaymentList = params => client.get("bill_payments", { params: params });

// eslint-disable-next-line
export const showBillPayment = id => client.get(`bills/${id}`);

export const showBillPayments = id => client.get(`bill_payments/${id}`);

export const withdrawRequest = params => client.post("/wallets/withdraw", { withdraw: params });

// eslint-disable-next-line
export const exportBills = params => client.post("bills/export", params);

// eslint-disable-next-line
export const checkBillsExportStatus = () => client.get("bills/check_export_status");

// eslint-disable-next-line
export const downloadBillsExport = params => client.get("bills/download_export", { params: params });

// eslint-disable-next-line
export const downloadBillPdf = id => client.get(`bills/${id}/pdf`, { responseType: 'blob' });

// eslint-disable-next-line
export const checkBillStatus = params => client.get(`bills/${params.id}`, { params: { check_status: params.check_status } });

// DARF Payment Methods
export const newDarfPayment = params => client.post("/bill_darfs", { bill_darf: params });

// eslint-disable-next-line
export const darfsPaymentList = params => client.get("bill_darfs", { params: params });

export const showDarfPayment = id => client.get(`bill_darfs/${id}`);

// PIX Payment Methods
export const newPixPayment = params => client.post("/pix_payments", { pix_payment: params });

// eslint-disable-next-line
export const pixPaymentsList = params => client.get("pix_payments", { params: params });

export const showPixPayment = id => client.get(`pix_payments/${id}`);

export const lookupPixKey = pixKey => client.post("/pix_payments/lookup_key", { pix_key: pixKey });

// eslint-disable-next-line
export const checkWalletExportStatus = () => client.get("wallets/export_status");

// eslint-disable-next-line
export const downloadWalletExport = params => client.get("wallets/download_export", { params: params });
